import { useMemo } from 'react'
import useEvent from 'react-use-event-hook'
import { SbpBank } from 'application/core/domain/useCase/sbp/useSbpBanks'
import { TextInput } from 'application/presentation/common/uiComponents'
import { useSearchField } from 'common/search/useSearchField'

import { SBPBankItem } from './SBPBankItem'
import s from './SBPChooseBank.module.scss'

type Props = {
  orderId: string
  banks?: SbpBank[]
  usedBanks?: string[]
  isLoading: boolean
  onBankSelected: (item: SbpBank) => void
  onBankSelectionError: (item: SbpBank) => void
}

export const SBPChooseBank = ({
  orderId,
  banks = [],
  usedBanks = [],
  onBankSelected,
  onBankSelectionError,
}: Props) => {
  const { query, setQuery, data } = useSearchField(banks, 'name')

  const sorted = useMemo(() => {
    return data
      .reduce(
        (acc: [SbpBank[], SbpBank[]], item: SbpBank) => {
          if (usedBanks.includes(item.name)) {
            acc[0].push(item)
          } else {
            acc[1].push(item)
          }

          return acc
        },
        [[], []],
      )
      .flat()
  }, [data, usedBanks])

  const handleChange = useEvent((e: any) => setQuery(e.target.value))

  return (
    <div className={s.container}>
      <div>Выберите банк:</div>
      <TextInput placeholder="Найти банк" value={query} onChange={handleChange} />
      {sorted.map((item) => (
        <SBPBankItem
          key={item.name}
          orderId={orderId}
          item={item}
          onSelected={onBankSelected}
          onCreateSBPPaymentError={onBankSelectionError}
        />
      ))}
    </div>
  )
}
